import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FenstertypPage } from '../fenstertyp/fenstertyp';

@Component({
  selector: 'page-aluminiumsysteme',
  templateUrl: 'aluminiumsysteme.html',
})
export class AluminiumsystemePage {
private producttype: string;
public items : Array<any> = [];
 private baseURI: string  = "http://test.lovanet.ch/arenafenster/app_controller/";
 
  constructor(public navCtrl: NavController, public navParams: NavParams, public http: HttpClient) {
  
  this.producttype = this.navParams.get('producttype');
  console.log(this.producttype); 
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AluminiumsystemePage');
  }
  
     ionViewWillEnter() : void
   {
      //this.load();
   }
   
    load(category_id: string): void
   {
      let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
          options: any = { "key": "product", "category_id": 2},
          url: any = this.baseURI + "retrieve-data.php";

      this.http.post(url, JSON.stringify(options), headers)
      .subscribe((data : any) =>
      {
         console.dir(data);
         this.items = data;
      },
      (error : any) =>
      {
         console.dir(error);
      });
   } 
   
   doRefresh(refresher) {
   this.load();
   refresher.complete();
   }
   
    selectProduct(name) {
    //console.log(name)
    this.navCtrl.push(FenstertypPage, {
    name: name
    }); 
  }


}



// WEBPACK FOOTER //
// ./src/pages/aluminiumsysteme/aluminiumsysteme.ts